import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { WebModal } from '@components/Modals/WebModal.web';
import { CopyProjectDetails } from '@components/Projects/CopyProjectDetails';
import { ProjectFormStackParamList } from '@components/Projects/ProjectFormStack';
import { Project } from '@graphql/generated';
import { useAppNavigation } from '@navigation/useAppNavigation';

export interface ProjectCopySelectProps {
  onProjectCopySelect?: (project: Project) => void;
}

export const ProjectCopySelect: React.FC<ProjectCopySelectProps> = ({
  onProjectCopySelect,
}) => {
  const { t } = useTranslation();
  const navigation = useAppNavigation();
  const route =
    useRoute<RouteProp<ProjectFormStackParamList, 'project-copy-select'>>();
  const { projectId, projectUUId } = route.params;

  return (
    <WebModal
      visible
      width={504}
      accessibilityLabel='Copy Project Details modal'
      title={t('shared:select')}
      onClose={navigation.goBack}>
      <CopyProjectDetails
        projectID={projectId}
        projectUUID={projectUUId}
        onProjectCopySelect={onProjectCopySelect}
      />
    </WebModal>
  );
};
